module.exports = "/_next/static/images/Cover-0e86f622357bf067fbd9f4ab76130a5f.webp";